<template>
  <div id="noon-report-edit">
    <vs-popup
      id="noon-report-edit-dialog"
      class="pr-32 pl-32"
      title="動静連絡編集"
      :active.sync="showDialog"
      :fullscreen="true"
    >
      <div class="scroll-area pl-4 pr-4 pb-4">
        <report-edit-form ref="ReportEditForm"></report-edit-form>
      </div>
      <div class="button-area flex items-center justify-center mt-12">
        <vs-button class="mr-2" :color="AISEA_COLOR.BLUE" @click="onClickUpdate"
          >更新する
        </vs-button>
        <vs-button :color="AISEA_COLOR.BLUE" type="border" @click="close"
          >キャンセル
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import ReportEditForm from "./components/ReportEditForm";
import { debounce } from "lodash";

import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("vesselNoonReportDetail");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    ReportEditForm,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions(["setReportDetail", "getReportDetail", "getReportItems"]),
    show() {
      this.showDialog = true;
    },
    onClickUpdate() {
      this.update(this);
    },

    update: debounce(async self => {
      self.$vs.loading();
      try {
        await self.$refs.ReportEditForm.postReportDetail();
        const payload = {
          vesselId: self.$route.params.vesselId,
          reportId: self.$route.params.reportId,
        };
        await self.getReportDetail(payload);
        await self.getReportItems();

        setTimeout(async () => {
          self.$vs.loading.close();
          self.close();
          self.$vs.notify({
            title: `編集内容が保存されました。`,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        }, 1000);
      } catch (error) {
        self.$vs.loading.close();
        self.$vs.notify({
          title: `動静連絡編集失敗`,
          text: `${error.msg}画面を再読み込みしてください。`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    }, 500),

    close() {
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#noon-report-edit-dialog {
  --vs-primary: $aisea-gray;
  font-family: $aisea-font-family;

  .vs-textarea {
    font-family: $aisea-font-family;
  }

  .calender-area {
    .send-date-range-calender {
      width: 128px;
      padding: 8px;
    }
  }

  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }

  .vue-treeselect--open .vue-treeselect__control {
    border-top-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__menu {
    box-shadow: 2px 5px 10px 0.5px #00000026;
    border-bottom-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__multi-value-item {
    color: $aisea-blue !important;
  }
}
</style>
